    $(document).ready(function() {
      $(document).on('click', '.product-grid-item__swatch .swatch__button', function() {
          $(this).parents('.product-grid-item__swatch').find('.swatch__button').removeClass('active_link');
        $(this).addClass('active_link');
      });
      $(document).on('click', '.mobile-menu__item .mobile-navlink', function (e) {
          e.preventDefault();
          $(document).find('.search-popdown__toggle').click()
      })
    });